import type { SxProps, Theme } from '@mui/material/styles';

export const onboardingOutlinedInputRootSx = {
  borderRadius: '12px',
  bgcolor: 'background.paper',
  transition:
    'box-shadow 0.2s ease, border-color 0.2s ease, background-color 0.2s ease',
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: 'grey.300',
    borderWidth: 1.5,
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: 'grey.500',
  },
  '&.Mui-focused': {
    boxShadow: '0 0 0 4px rgba(86,190,219,0.18)',
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: '#203097',
    },
  },
} as const;

export const onboardingOutlinedInputFocusedSx = {
  ...onboardingOutlinedInputRootSx['&.Mui-focused'],
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: '#203097',
    borderWidth: 1.5,
  },
} as const;

export const onboardingTransactionFieldSx: SxProps<Theme> = {
  '& .MuiOutlinedInput-root': onboardingOutlinedInputRootSx,
  '& .MuiOutlinedInput-input, & .MuiSelect-select': {
    fontSize: 14,
    fontWeight: 500,
    py: 1.125,
    px: 1.25,
  },
  '& .MuiInputLabel-root': {
    fontSize: 13,
    fontWeight: 600,
    color: 'text.primary',
    mb: 0.5,
    position: 'relative',
    transform: 'none',
    '&.Mui-focused': { color: 'text.primary' },
  },
  '& .MuiFormControl-root': {
    width: '100%',
  },
  '& .MuiFormHelperText-root': {
    ml: 0.5,
    mt: 0.5,
    fontSize: 12,
  },
};
